import React from 'react';
import { IBlock, IBlockData } from '../../../typings';
import { BasicType } from '../../../constants';
import { merge } from 'lodash';
import { createBlock, t } from '../../../utils';
import { BasicBlock } from '../../../components/BasicBlock';

export type IGroup = IBlockData<{
    width?: string;
    'vertical-align'?: 'middle' | 'top' | 'bottom';
    'background-color'?: string;
    direction?: 'ltr' | 'rtl';
}>;

export const Group: IBlock<IGroup> = createBlock({
    get name() {
        return t('Group');
    },
    type: BasicType.GROUP,
    create: (payload: any) => {
        const defaultData: IGroup = {
            type: BasicType.GROUP,
            data: {
                value: {},
            },
            attributes: {
                'vertical-align': 'top',
                direction: 'ltr',
            },
            children: [],
        };
        return merge(defaultData, payload);
    },
    validParentType: [BasicType.SECTION],

    render(params: any) {
        return <BasicBlock params={params} tag="mj-group" />;
    },
});
